import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ViewChild } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Message } from 'primeng/api';
import { NotificationService } from '../../../shared/services/notification.service';
import { OPCConstant } from '../../../opc-app/opc.const';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { PartGroup } from '../../../opc-app/partgroup/partgroup.model';
import { PartCategory } from '../../../opc-app/partcategory/partcategory.model';
import { ProductLine } from '../../../opc-app/productline/productline.model';
import { ProductLinePartGroup } from '../../../opc-app/partgroup/productlinepartgroup.model';
import { PartGroupService } from '../../../shared/services/partgroup.service';
import { OPCSettings } from '../../../shared/models/opcsettings.model';

@Component({
  selector: 'app-partgroup-item',
  templateUrl: './partgroup-item.component.html',
})
export class PartGroupItemComponent implements OnInit {
  @Input() partGroup: PartGroup;
  @Input() partCategories: PartCategory[];
  @Input() productLines: ProductLine[];
  @Input() productLineOptions: SelectItem[];
  @Input() i: string;
  @Output() isSubmited: EventEmitter<any> = new EventEmitter();
  @Output() isDeleted: EventEmitter<any> = new EventEmitter();
  @Output() erroremit: EventEmitter<any> = new EventEmitter();
  @ViewChild('fileUpload')
  fileUpload: any;
  clonePartGroup: PartGroup;
  file: any;
  notifications: Message[] = [];
  pgName: string;
  pgFormGroup: FormGroup;
  pgDescField: FormControl;
  associatePC: FormControl;
  selectedPL: number[] = [];
  showImage: boolean;
  partGroupImgPath: String;
  opcSettings: OPCSettings = new OPCSettings();
  indexOrderID: FormControl;
  allPartGroups: any;
  addIndex: boolean;
  newPartGroup: PartGroup;
  partGroups: PartGroup[];
  showToast: boolean = false;
  showSuccess: boolean = false;
  showSuccessMessage = false;
  constructor(private _partGroupService: PartGroupService, private confirmationService: ConfirmationService,
    private notifyService: NotificationService, private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.addIndex = this._partGroupService.addIndex;
    this.clonePartGroup = Object.assign({}, this.partGroup);
    this.pgName = this.partGroup.partGroupDesc ? this.partGroup.partGroupDesc : '';
    this.defaultDropDown();
    this.showImage = false;
    this.formControlValidation();
    this.formGroupValidation();
    this.getAllPartgroups();
  }
  formControlValidation() {
    this.pgDescField = new FormControl('', [
      Validators.required,
      Validators.maxLength(120),
      Validators.minLength(3)
    ]);
    this.associatePC = new FormControl('', [
      Validators.required
    ]);
    this.indexOrderID = new FormControl('');
  }
  formGroupValidation() {
    this.pgFormGroup = this.fb.group({
      pgDescField: this.pgDescField,
      associatePC: this.associatePC,
      indexOrderID: this.indexOrderID,
    });
  }
  onUpload(event) {
    const fileBrowser = this.fileUpload.nativeElement;
    if (fileBrowser.files && fileBrowser.files[0]) {
      this.file = fileBrowser.files[0];
    }
    if (!(this.file.size > this.opcSettings.minImageSize
      && this.file.size < this.opcSettings.maxImageSize
      && this.file.type === this.opcSettings.validImageFormat)) {
      this.notifications = this.notifyService.growlNotification('warn', OPCConstant.INVALID_IMAGE_UPLOAD);
      event.srcElement.value = '';
      this.file = undefined;
    }
  }
  onShowImage() {
    this.showImage = true;
  }
  //Commented for avoiding multiple calls to the API in order to reduce the performance issue in partGroup section

  getAllPartgroups() {
    this._partGroupService.getAllPartGroups().subscribe((res) => {
      this.allPartGroups = res.item1;
    })
  }

  savedPartGroup(event) {
    this.newPartGroup = new PartGroup();
    const pg = this.allPartGroups.find(p => p.partGroupID === event.partGroupID);
    if (pg) {
      this.showSuccess = true;
      setTimeout(() => {
        this.showSuccess = false;
      }, 3000);
    }
  }


  onSubmit(i: number) {
    if (this.pgFormGroup.valid) {
      this.partGroup.productLinePartGroup = Array<ProductLinePartGroup>();
      for (let i = 0; i < this.selectedPL.length; i++) {
        this.partGroup.productLinePartGroup.push({
          productLineID: this.selectedPL[i],
          partGroupID: this.partGroup.partGroupID
        });
      }
      if (!this.pgName) {
        this._partGroupService.addOrUpdatePartGroup(this.partGroup, this.file, true).subscribe((res: PartGroup) => {
          this.isSubmited.emit(res);
          this.ngOnInit();
        },
          error => {
            const errorMessage = error.error.Message ? error.error.Message : OPCConstant.UPDATE_FAILURE;
            this.notifications = this.notifyService.growlNotification('fail', errorMessage);
            this.isSubmited.emit(undefined);
          });
      }
      else {
        this._partGroupService.addOrUpdatePartGroup(this.partGroup, this.file, false).subscribe((res: PartGroup) => {
          this.savedPartGroup(res);
          setTimeout(() => {
            const collapseElement = document.getElementById('collapse' + i);
            if (collapseElement) {
              collapseElement.classList.remove('show');  
            }
            this.showSuccessMessage = false;
          }, 3000);
          setTimeout(() => this.isSubmited.emit(res), 3000);
        },
          error => {
            const errorMessage = error.error.Message ? error.error.Message : OPCConstant.UPDATE_FAILURE;
            this.notifications = this.notifyService.growlNotification('fail', errorMessage);
            this.isSubmited.emit(undefined);
          });
      }
    }
    else {
      this.notifications = this.notifyService.growlNotification('warn', OPCConstant.UPDATE_WARNING);
    }
  }
  onExpand() {
    // TO DO
  }
  onDelete(item: number, index: string) {
    if (item) {
      this.confirmationService.confirm({
        header: 'Delete Confirmation',
        key: index,
        message: OPCConstant.CONFIRM_MESSAGE,
        accept: () => {
          this._partGroupService.deletePartGroup(item).subscribe(
            res => {
              this.isDeleted.emit(true);
            },
            error => {
              this.erroremit.emit("");
            }
          );
        }
      });
    } else {
      this.isDeleted.emit(true);
    }
  }
  defaultDropDown() {
    if (this.partGroup.productLinePartGroup) {
      for (let i = 0; i < this.partGroup.productLinePartGroup.length; i++) {
        this.selectedPL.push(this.partGroup.productLinePartGroup[i].productLineID);
      }
    }
    this.partGroup.partCategoryID = this.partCategories.find(p => p.partCategoryID === this.partGroup.partCategoryID)
      ? this.partGroup.partCategoryID : undefined;
  }
  onReset() {
    this.partGroup = Object.assign({}, this.clonePartGroup);
    this.selectedPL = [];
    this.defaultDropDown();
    this.fileUpload.nativeElement.value = '';
    this.file = undefined;
    if (!this.partGroup.partGroupID) {
      this.pgFormGroup.reset();
    }
    this.pgFormGroup.markAsUntouched();
  }
}



// WEBPACK FOOTER //
// ./src/opc/opc-admin/partgroup/partgroup-item/partgroup-item.component.ts